import {type ReactNode} from "react";

interface PanelProps {
    children: ReactNode,
    title?: string,
    footer?: ReactNode,
}

export function Panel({
                          children,
                          title,
                          footer
                      }: PanelProps) {
    return (
        <div className="algoliaAutocompletePanel">
            {title && <div className="algoliaAutocompletePanel__header"><h3>{title}</h3></div>}
            <div className="algoliaAutocompletePanel__body">{children}</div>
            {footer && <div className="algoliaAutocompletePanel__footer">{footer}</div>}
        </div>
    );
}